

export function validationSchedule (val) {
  let showError = true
  Object.keys(val).forEach(day => {
    if (val[day].value.trim() !== '') showError = false
  })
  return showError ? 'error' : false
}
